import * as React from "react";
import type { SVGProps } from "react";
const SvgSuitcaseOnWheelsBadgePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 1a2 2 0 0 0-2 2v4H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1v1a1 1 0 1 0 2 0v-1h4v1a1 1 0 1 0 2 0v-1h1a2 2 0 0 0 2-2v-3.498a6.502 6.502 0 0 0-4-12.328V3a2 2 0 0 0-2-2zm2 3.022V3h-2v3.034a6.5 6.5 0 0 1 2-2.012M10.019 9H7v10h10v-3.019A6.5 6.5 0 0 1 10.019 9m6.481 5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-1c-.55 0-1-.45-1-1v-1.5H14c-.55 0-1-.45-1-1s.45-1 1-1h1.5V7c0-.55.45-1 1-1s1 .45 1 1v1.5H19c.55 0 1 .45 1 1s-.45 1-1 1h-1.5V12c0 .55-.45 1-1 1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSuitcaseOnWheelsBadgePlus;
